import React from 'react';
import loaderGif from '../assets/loader.gif'; // adjust path if needed
import loaderGifSmall from '../assets/loadersmall.gif'; // adjust path if needed


const Loader = ({ size = 'medium', fullscreen = false, text }) => {
  const sizeClasses = {
    small: 'w-8 h-8',
    medium: 'w-16 h-16',
    large: 'w-24 h-24',
  };

  if (fullscreen) {
    return (
      <div className="fixed inset-0 bg-white bg-opacity-80 flex flex-col items-center justify-center z-50">
        <img
          src={loaderGif}
          alt="Loading..."
          className={`${sizeClasses[size]} object-contain`}
        />
        {text && <p className="mt-4 text-gray-700">{text}</p>}
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center justify-center">
      <img
        src={loaderGifSmall}
        alt="Loading..."
        className={`${sizeClasses[size]} object-contain`}
      />
      {text && <p className="mt-2 text-gray-700 text-sm">{text}</p>}
    </div>
  );
};

export default Loader;
